<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:24:52
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-24 16:01:55
--> 
<template>
  <div>
    <mrc_ess_iconGroup :is_disabled='readonly'
                       :showReturn='false'
                       :showEdit="hasBtn('edit-static-resource')"
                       :show_del="hasBtn('delete-static-resource')"
                       @handleEdit='handleEdit'
                       @handleDel='handleDel'></mrc_ess_iconGroup>
    <staticResource :disabled='readonly'
                    @changeReadonly='handleEdit'></staticResource>
  </div>
</template>

<script>
import {
  static_resource_delete,
} from '@/service/api/staffGrade.js'
import staticResource from './staticResource.vue'
export default {
  components: {
    staticResource
  },
  props: {},
  data () {
    return {
      readonly: false,
      list: {}
    };
  },
  computed: {},
  created () {
  },
  watch: {
    readonly: {
      handler (v) {
        if (!this.$store.state.uuid) return
        if (!v) {
          this.$route.meta.title = 'label_edit_static_resource'
          this.$store.commit('set_page_title', 'label_edit_static_resource')
        }
        else {
          this.$route.meta.title = 'label_view_static_resource'
          this.$store.commit('set_page_title', 'label_view_static_resource')
        }
      }, immediate: true
    }
  },
  mounted () {
    this.readonly = this.$store.state.iconstatus
  },
  beforeDestroy () {

  },
  methods: {
    handleEdit () {
      this.readonly = !this.readonly
      this.$store.commit('set_iconstatus', this.readonly)
    },
    handleDel () {
      this.$myConfirm({ content: this.$t('message_Confirm_the_deletion') }).then(res => {
        static_resource_delete({ uuid: this.$store.state.uuid }).then(res => {
          if (res.code == 200) {
            this.$Message({ text: this.$t('message_The_deletion_was_successful') })
            this.$router.push({
              name: 'staticResource',
              params: {
                type: 'del'
              }
            })
          }
        })
      })
    },
  },
};
</script>

<style scoped>
</style>
